import React from "react";
import "./conclave css files/bannerconclave.css";
const quote_self = require("../../assets/conclave assets/kouma.png");
const design_8 = require("../../assets/conclave assets/gray_dots.png");

function BannerConclave(props) {
  return (
    <section className="main_banner_conclave_container">
      <div className="main_banner_under_conclave_container">
        <div className="flex_conclave_container">
          <div className="partition_one_content_container">
            <div className="quote_container">
              <img src={quote_self} alt="quote" loading="lazy" />
            </div>
            <p className="banner_content_text">
              With{" "}
              <strong className="yellow_banner_highlighted_txt">
                64000 students
              </strong>{" "}
              counselled,{" "}
              <strong className="yellow_banner_highlighted_txt">
                84000+ courses
              </strong>
              , and{" "}
              <strong className="yellow_banner_highlighted_txt">3300+</strong>{" "}
              affiliated education partners spread across{" "}
              <strong className="yellow_banner_highlighted_txt">
                20+ countries
              </strong>
              , DWEC has come a long way by handholdingstudents in their
              education journey.
            </p>
            <p className="light_paragraph_content_text">
              We guide, mentor and handhold students with global possibilities
              by broadening their scope & widening their dreams with global
              education, since 2020.
            </p>
          </div>
          <div className="partition_two_content_container"></div>
        </div>
        <div className="design_8_container">
          <img src={design_8} alt="design_8" loading="lazy" />
        </div>
      </div>
    </section>
  );
}

export default BannerConclave;
